import spinRoute from '../../router/spinRoute.js';

//通讯录 所有页面
export default () => [
    {
        path: '/addressbook/addressbook',
        component: () => spinRoute.require(import('./addressBookContainer.vue')),
        meta: { title: kygMsg(4000166, '通讯录') },
        redirect: '/addressbook/orgTree',
        children: [
            {
                path: '/addressbook/orgTree',
                component: () => spinRoute.require(import('./addressBook.vue')),
                meta: { title: kygMsg(4000166, '通讯录'), keepAlive: true, noGoBack: true },
            },
            {
                path: '/addressbook/organizationDetail',
                component: () => spinRoute.require(import('./organizationDetail.vue')),
                meta: { title: kygMsg(4000166, '通讯录'), keepAlive: true, },
            },
            {
                path: '/addressbook/searchResult',
                component: () => spinRoute.require(import('./searchResult.vue')),
                meta: { title: kygMsg(4000166, '通讯录') },
            },
            {
                path: '/addressbook/employeeDetail',
                component: () => spinRoute.require(import('./employeeDetail.vue')),
                meta: { hideBarFoot: true, },
            },
        ]
    },
]
